import { ColumnDef } from "@tanstack/react-table";
import { RoleProps } from "../../store/actionType";
import ActionButton from "../ActionButton";

export const TableColumns: ColumnDef<RoleProps>[] = [

  {
    id: "slNo",
    header: "Sl. No",
    cell: ({ row }) => row.index + 1,
  },
  {
      accessorFn: (row) => row?.name,
      id: "name",
      cell: (info) => info.getValue(),
      header: () => <span>Role</span>,
      filterFn: "equalsString",
    },
  {
      accessorFn: (row) => row?.description,
      id: "description",
      cell: (info) => info.getValue(),
      header: () => <span>Description</span>,
      filterFn: "equalsString",
    },
  {
    id: "action",
    cell: ({ row }) => {

      return (

      <div className="flex justify-center items-center gap-2">
         <ActionButton items={row.original}/>
      </div>
    )},
    header: () => <span>Actions</span>,
    enableSorting: false,
  },
];
